export default {"src":"/_next/static/media/airdrop-ineligible-illustration.301996d0.svg","height":221,"width":278};